import { useRef } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  IconButton,
  Tooltip,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

export default function MoreInfoDrawer({ title, size = 'lg', isLoading = false, children }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  return (
    <>
      <Tooltip label={title || 'More Information'} placement="auto">
        <IconButton
          ref={btnRef}
          onClick={onOpen}
          borderRadius="full"
          colorScheme="blue"
          variant="outline"
          ml={3}
          isDisabled={isLoading}
        >
          <Text color="inherit" fontSize="xl">?</Text>
        </IconButton>
      </Tooltip>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size={size}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            {title}
          </DrawerHeader>
          <DrawerBody>
            {children}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
